export function isValidCnpj(cnpj) {
    if (!cnpj) {
        return false;
    }
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (cnpj.length !== 14) {
        return false;
    }
    if (/^(\d)\1{13}$/.test(cnpj)) {
        return false;
    }
    var calculateDigit = function (base, weights) {
        var sum = base
            .split('')
            .reduce(function (acc, num, index) { return acc + parseInt(num, 10) * weights[index]; }, 0);
        var remainder = sum % 11;
        return remainder < 2 ? 0 : 11 - remainder;
    };
    var weightsFirstDigit = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    var weightsSecondDigit = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    var baseCnpj = cnpj.substring(0, 12);
    var firstDigit = calculateDigit(baseCnpj, weightsFirstDigit);
    var secondDigit = calculateDigit(baseCnpj + firstDigit, weightsSecondDigit);
    return cnpj === baseCnpj + firstDigit.toString() + secondDigit.toString();
}
